import { gql } from '@apollo/client/core';

export const SUBMIT_RATING_MUTATION = gql`
  mutation createReview($id: UUID!, $stars: Stars!, $reviewee: UUID!, $publicFeedback: String, $privateFeedback: String) {
    createReview(
      id: $id
      stars: $stars
      reviewee: $reviewee
      publicFeedback: $publicFeedback
      privateFeedback: $privateFeedback
    ) {
      id
      stars
      reviewerID
      revieweeID
      publicFeedback
      at
    }
  }
`;

export const UPDATE_REVIEW_MUTATION = gql`
  mutation ($id: UUID!, $stars: Stars!, $publicFeedback: String) {
    updateReview(id: $id, stars: $stars, publicFeedback: $publicFeedback) {
      id
      stars
      reviewerID
      revieweeID
      publicFeedback
      at
    }
  }
`;

export const CREATE_EXTERNAL_REVIEW_REQUEST_MUTATION = gql`
  mutation ExternalProviderReviewRequests {
    externalProviderReviewRequests {
      create {
        reviewToken
      }
    }
  }
`;

export const CREATE_EXTERNAL_REVIEW_MUTATION = gql`
  mutation CreateProviderReviewFromExternalRequest(
    $reviewToken: UUID!
    $stars: Stars!
    $publicFeedback: String
    $privateFeedback: String
    $reviewerEmail: String!
    $reviewerFirstName: String!
    $reviewerLastName: String!
  ) {
    externalProviderReviewRequests {
      createProviderReview(
        reviewToken: $reviewToken
        stars: $stars
        publicFeedback: $publicFeedback
        privateFeedback: $privateFeedback
        reviewerEmail: $reviewerEmail
        reviewerFirstName: $reviewerFirstName
        reviewerLastName: $reviewerLastName
      ) {
        id
        publicFeedback
        stars
      }
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation ExternalProviderReviewRequests($reviewToken: UUID!) {
    externalProviderReviewRequests {
      resendEmailVerification(reviewToken: $reviewToken) {
        success
      }
    }
  }
`;

export const CONFIRM_EMAIL_MUTATION = gql`
  mutation ExternalProviderReviewRequests($reviewToken: UUID!, $emailVerificationToken: String!) {
    externalProviderReviewRequests {
      confirmEmail(reviewToken: $reviewToken, emailVerificationToken: $emailVerificationToken) {
        success
      }
    }
  }
`;
